import React from "react";

import FieldConfig from "../../../proto/field-config";
import FieldTotal from "../../../generic/total/total/total";

export default class FieldCrmContactsTotal extends FieldTotal {


    constructor(config:FieldConfig) {
        super(config);

        this.components = {
            ValueIcon: <span className={Classes("ui5-ico-16 m-r-8 fl-no-shrink i5-crm-contact")}/>
        }

    }

    getViewValue(model:any) {
        return model['contacts']?model['contacts'].length:0;
    }

    normalizeToCSVValue(model:any): any {
        return this.getViewValue(model)
    }
}
